import "./CapabilityGrid.css";
import { motion, useReducedMotion } from "framer-motion";

const CAPABILITIES = [
  {
    title: "QR menü & rendelés",
    desc: "Vendégeid a saját telefonjukról böngészhetik az étlapot és rendelhetnek — alkalmazás letöltése nélkül.",
  },
  {
    title: "Pincér rendelésfelvétel",
    desc: "Munkatársaid gyors, POS-szerű felülettel vehetik fel a rendeléseket asztalhoz.",
  },
  {
    title: "Asztal- és teremkezelés",
    desc: "Lásd át éttermed alaprajzát, és kövesd valós időben, mely asztal foglalt.",
  },
  {
    title: "Valós idejű rendeléskövetés",
    desc: "Minden új rendelés azonnal megjelenik a kezelőfelületen, hang- és értesítéssel.",
  },
  {
    title: "Többnyelvű étlap",
    desc: "Az étlap magyarul, angolul és németül is elérhető — automatikusan.",
  },
  {
    title: "Egyedi márkajelzés",
    desc: "Saját logó és színvilág az étlapon, hogy vendégeid rád ismerjenek.",
  },
  {
    title: "Testre szabható QR kódok",
    desc: "Színek, stílus, logó — és PNG, SVG vagy PDF formátumban letölthető.",
  },
  {
    title: "Dashboard & statisztikák",
    desc: "Bevétel, népszerű ételek és csúcsidőszakok — mindig kéznél.",
  },
  {
    title: "Csapatkezelés",
    desc: "Hívj meg munkatársakat, és kezeld a jogosultságaikat egy kattintással.",
  },
];

const gridVariants = {
  hidden: {},
  show: { transition: { staggerChildren: 0.055 } },
};

const itemVariants = {
  hidden: { opacity: 0, y: 18, scale: 0.97 },
  show: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.45, ease: [0.16, 1, 0.3, 1] } },
};

function CapabilityGrid() {
  const prefersReducedMotion = useReducedMotion();

  return (
    <section className="landing-capability-section">
      <div className="landing-container">
        <h2 className="landing-section-title fade-up">
          Egy rendszer, minden, amire egy modern étteremnek szüksége van
        </h2>

        <p className="landing-capability-subtitle fade-up">
          A Tablify nem csak egy QR-étlap — teljes éttermi irányítási rendszer,
          az asztaltól a statisztikákig.
        </p>

        <motion.div
          className="landing-capability-grid"
          initial={prefersReducedMotion ? false : "hidden"}
          whileInView={prefersReducedMotion ? undefined : "show"}
          viewport={{ once: true, amount: 0.2 }}
          variants={prefersReducedMotion ? undefined : gridVariants}
        >
          {CAPABILITIES.map((cap) => (
            <motion.div
              className="landing-capability-item"
              key={cap.title}
              variants={prefersReducedMotion ? undefined : itemVariants}
              whileHover={prefersReducedMotion ? undefined : { y: -6 }}
            >
              <h3>{cap.title}</h3>
              <p>{cap.desc}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}

export default CapabilityGrid;
